import React from 'react';
import { useTranslation } from 'react-i18next';
import { FAQAccordion } from '../components/FAQAccordion';

export function FAQPage() {
  const { t } = useTranslation();

  const categories = [
    'general',
    'technical',
    'hosting',
    'gameServers',
    'security'
  ];

  return (
    <div className="pt-16">
      <div className="bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-6">{t('faq.title')}</h1>
          <p className="text-xl text-blue-100">{t('faq.subtitle')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="space-y-8">
          {categories.map((category) => (
            <FAQAccordion
              key={category}
              title={t(`faq.categories.${category}.title`)}
              questions={t(`faq.categories.${category}.questions`, { returnObjects: true })}
            />
          ))}
        </div>
      </div>
    </div>
  );
}